import { render, staticRenderFns } from "./AppTableEmpty.vue?vue&type=template&id=268937dd&scoped=true&"
var script = {}
import style0 from "./AppTableEmpty.vue?vue&type=style&index=0&id=268937dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268937dd",
  null
  
)

export default component.exports